





















































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class AdminView extends Vue {
  get conference() {
    return this.$store.getters.getConferenceId;
  }

  get conferenceTitle() {
    return this.$store.getters.getConferenceTitle;
  }

  get isAdmin() {
    return this.$store.getters.isAdmin;
  }
  get isSuperAdmin() {
    return this.$store.getters.isSuperAdmin;
  }

  get hasEditConferences() {
    return this.$store.getters.hasEditConferences;
  }

  get hasEditContent() {
    return this.$store.getters.hasEditContent;
  }

  get hasEditMembers() {
    return this.$store.getters.hasEditMembers;
  }

  get hasEditArticles() {
    return this.$store.getters.hasEditArticles;
  }

  get hasEditAdmins() {
    return this.$store.getters.hasEditAdmins;
  }

  menu: any = {
    addMembers: false,
    allMembers: false,
    isReviewer: false,
    isInvitedSpeaker: false,
    isChairman: false,
    isInternationalCommittee: false,
    isLocalCommittee: false,
    isScientificCommittee: false,
    insertConference: false,
    deleteConference: false,
    carousel: false,
    about: false,
    dates: false,
    info: false,
    topics: false,
    publication: false,
    programme: false,
    venue: false,
    registration: false,
    sponsors: false,
    accepted: false,
    rejected: false,
    underReview: false,
    isAdmin: false,
  };

  displayEditConference(item: string) {
    this.$emit("displayEditConference", item);
    Object.keys(this.menu).forEach((key) => (this.menu[key] = false));
    this.menu[item] = true;
  }

  displayEditContent(item: string) {
    this.$emit("displayEditContent", item);
    Object.keys(this.menu).forEach((key) => (this.menu[key] = false));
    this.menu[item] = true;
  }

  displayEditMembers(item: string) {
    this.$emit("displayEditMembers", item);
    Object.keys(this.menu).forEach((key) => (this.menu[key] = false));
    this.menu[item] = true;
  }

  displayEditChairmen(item: string) {
    this.$emit("displayEditChairmen", item);
    Object.keys(this.menu).forEach((key) => (this.menu[key] = false));
    this.menu[item] = true;
  }

  displayEditArticles(item: string) {
    this.$emit("displayEditArticles", item);
    Object.keys(this.menu).forEach((key) => (this.menu[key] = false));
    this.menu[item] = true;
  }

  displayEditAdmins(item: string) {
    this.$emit("displayEditAdmins", item);
    Object.keys(this.menu).forEach((key) => (this.menu[key] = false));
    this.menu[item] = true;
  }
}
